export default __webpack_public_path__ + "static/media/notification_menu.3422d034.png";